import { UpmindObjectTypes } from "@/data/enums/objects";
import { IImportMappingSource } from "@/models/imports";

// Sources
import { ClientSource } from "@/data/imports/mappingSources/client";
import { CurrencySource } from "@/data/imports/mappingSources/currency";
import { CustomFieldSource } from "@/data/imports/mappingSources/customField";
import { GatewaySource } from "@/data/imports/mappingSources/gateway";
import { GroupSource } from "@/data/imports/mappingSources/group";
import { ProductSource } from "@/data/imports/mappingSources/product";
import { ProductCategorySource } from "@/data/imports/mappingSources/productCategory";
import { ProvisionConfigurationSource } from "@/data/imports/mappingSources/provisionConfiguration";
import { TicketDepartmentSource } from "@/data/imports/mappingSources/ticketDepartment";
import { TicketPrioritySource } from "@/data/imports/mappingSources/ticketPriority";
import { TicketStatusSource } from "@/data/imports/mappingSources/ticketStatus";
import { UserSource } from "@/data/imports/mappingSources/user";

export const ImportMappingSource = (
  sourceType: UpmindObjectTypes
): IImportMappingSource => {
  switch (sourceType) {
    case UpmindObjectTypes.CLIENT:
      return ClientSource;
    case UpmindObjectTypes.CURRENCY:
      return CurrencySource;
    case UpmindObjectTypes.CUSTOM_FIELD:
      return CustomFieldSource;
    case UpmindObjectTypes.GATEWAY:
      return GatewaySource;
    case UpmindObjectTypes.GROUP:
      return GroupSource;
    case UpmindObjectTypes.PRIORITY:
      return TicketPrioritySource;
    case UpmindObjectTypes.PRODUCT:
      return ProductSource;
    case UpmindObjectTypes.PRODUCTS_CATEGORY:
      return ProductCategorySource;
    case UpmindObjectTypes.PROVISION_CONFIGURATION:
      return ProvisionConfigurationSource;
    case UpmindObjectTypes.STATUS:
      return TicketStatusSource;
    case UpmindObjectTypes.TICKET_DEPARTMENT:
      return TicketDepartmentSource;
    case UpmindObjectTypes.USER:
      return UserSource;
    default:
      return {} as IImportMappingSource;
  }
};
